 
 
import {agentDeveloperUtils} from 'wobi-web-common';

class Agent {
  /**
   * Agent constructor
   *
   * @class
   * @param {string} name
   * @param {string} developerName
   * @param {string} displayName
   * @param {string} isFollowUpEnabled
   */
  constructor(name, developerName, displayName, isFollowUpEnabled) {
    this.name = name;
    this.developerName = developerName;
    this.displayName = displayName;
    this.isFollowUpEnabled = isFollowUpEnabled;
  }

  get getName() {
    return this.name;
  }

  get getDisplayName() {
    return this.displayName;
  }

  get getDeveloperName() {
    return this.developerName;
  }

  get getLogoName() {
    return 'companyLogo';
  }

  get getFormsEmailAddress() {
    return this.formsEmailAddress;
  }

  get getAssetsPath() {
    return `assets/images/agents/${this.developerName}`;
  }

  get getIsFollowUpEnabled() {
    return this.isFollowUpEnabled;
  }

  get getAgentLogoPath() {
    if (this.developerName === 'Wobi') {
      return `${this.getAssetsPath}/${this.getLogoName}.svg`;
    } else {
      return `${this.getAssetsPath}/${this.getLogoName}.png`;
    }
  }

  getAgentImagePath(imageName) {
    return `${this.getAssetsPath}/${imageName}`;
  }
}

const imageModules = import.meta.glob('../assets/images/agents/**/*.{png,jpg,jpeg,svg,gif,webp}', {
  eager: true,
  import: 'default',
});

const imageCache = {};
Object.keys(imageModules).forEach((path) => {
  const normalized = path
    .replace('../assets/images/agents/', '')
    .replace(/^\//, '');
  imageCache[normalized] = imageModules[path];
});

export const getImageByAgent = (imageName, config) => {
  const agent = new Agent(
    agentDeveloperUtils.agentData.Agent_Developer_Name_c,
    agentDeveloperUtils.agentData.Agent_Developer_Name_c,
    agentDeveloperUtils.getAgentDisplayName,
  );

  let finalImageName = imageName;
  if (config && config[agent.getDeveloperName]) {
    finalImageName = config[agent.getDeveloperName];
  }

  const lookupKey = `${agent.getDeveloperName}/${finalImageName}`;

  if (imageCache[lookupKey]) {
    return imageCache[lookupKey];
  }

  const foundKey = Object.keys(imageCache).find(
    (key) => key.toLowerCase() === lookupKey.toLowerCase(),
  );

  if (foundKey) {
    return imageCache[foundKey];
  }

  console.warn(`[getImageByAgent] Image not found: ${lookupKey}`);
  return agent.getAgentImagePath(finalImageName);
};

export default Agent;